import { takeLatest, put, call } from 'redux-saga/effects';
import { CHECK_TOKEN_SAGA } from "../sagaTypes";
import { startApp, setUser } from "../rootReducer";
import { url } from "../../config";
import { getLocalStorage, setLocalStorage } from "../../helpers/LocalStorage";

const request = data => {
    return fetch(`${ url }/check_token`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerCheckTokenSaga() {
    try {
        const token = yield getLocalStorage('afp_fitness');
        let formData = new FormData();
        formData.append('token', token || '');

        const response = yield call (request, formData);

        if (response.void) {
            setLocalStorage('afp_fitness', '').then();
            yield put(startApp());
        }
        else if (response.success) {
            // Добавляю user в redux
            yield put(setUser(response.user));
        }
    }
    catch(error) {
        console.log(error);
        yield put(startApp());
    }
}

export default function* watcherCheckToken() {
    yield takeLatest(CHECK_TOKEN_SAGA, workerCheckTokenSaga);
}